import { render, staticRenderFns } from "./delivery-jobcast.vue?vue&type=template&id=01f52cec"
import script from "./delivery-jobcast.vue?vue&type=script&lang=js"
export * from "./delivery-jobcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports